export default "__VITE_ASSET__BTtxY0Nk__"